import { render } from "./QueCorrect.vue?vue&type=template&id=16c5140a"
import script from "./QueCorrect.vue?vue&type=script&lang=js"
export * from "./QueCorrect.vue?vue&type=script&lang=js"

import "./QueCorrect.vue?vue&type=style&index=0&id=16c5140a&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__